import * as actions from './actions'
import { TimePickerState } from './model'
import { TimePickerActions } from './actions'
import { OFF } from './TimeOption';

const initialState: TimePickerState = <TimePickerState> {
  time: {
    from: '',
    to: ''
  },
  initialDate: {
    label: '',
    value: {
      amount: 1,
      format: 'hours'
    }
  },
  refresh: OFF,
  isRefreshing: false,
  isApiLoading: true
};

const reducer = (state: TimePickerState = initialState, action: TimePickerActions): TimePickerState => {
  switch (action.type) {
    case actions.TimePickerSet:
    case actions.TimePickerChange:
      return {
        ...state,
        time: action.payload.time,
        refresh: action.payload.refresh,
        initialDate: action.payload.initialDate,
        isApiLoading: false
      };
    case actions.RefreshChange:
      return {
        ...state,
        isRefreshing: action.payload.isRefreshing
      };
    case actions.ApiStateChange:
      return {
        ...state,
        isApiLoading: action.payload.isLoading
      };
    default:
      return state
  }
};

export default reducer
